import { Sparkles, HeartHandshake, Compass, Layers } from "lucide-react";
import { valueCards } from "@/data/content";

const iconMap = { Sparkles, HeartHandshake, Compass, Layers };

export default function BrandIntro() {
  return (
    <section id="about" className="relative py-20 md:py-28 bg-[var(--aura-ivory-2)]">
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-14">
        <div className="grid lg:grid-cols-12 gap-10 items-end">
          <div className="lg:col-span-6">
            <span className="eyebrow">Brand · Intro</span>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight mt-3 leading-[1.1]">
              What Aura Events stands for
            </h2>
          </div>
          <div className="lg:col-span-5 lg:col-start-8">
            <p className="font-body text-base md:text-lg text-[var(--aura-charcoal-2)] leading-relaxed">
              Aura is built for people who want more than passive events. We
              create experiences that help people learn something useful, meet
              the right people, reset their routines, explore new ideas, and
              leave with a sense of momentum.
            </p>
          </div>
        </div>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {valueCards.map((c) => {
            const Icon = iconMap[c.icon];
            return (
              <div
                key={c.title}
                className="group relative p-7 bg-white rounded-2xl border border-black/5 hover:-translate-y-1 hover:shadow-lg transition-all duration-300"
              >
                <div className="w-11 h-11 rounded-xl flex items-center justify-center bg-[var(--aura-teal)]/8 text-[var(--aura-teal)]">
                  <Icon size={20} strokeWidth={1.75} />
                </div>
                <h3 className="mt-5 font-display text-xl leading-snug">
                  {c.title}
                </h3>
                <p className="mt-2 font-body text-sm text-[var(--aura-charcoal-2)] leading-relaxed">
                  {c.body}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
